export default __webpack_public_path__ + "static/media/calculate-buying-power.d1517d3e.png";